import request from '../utils/request';
export function getInit(data) {
  return request({
    url: '/frontExhibitor/lintel/lintelView',
    method: 'get',
    params: data,
  });
}
// 提交标摊门楣信息
export function submitBooth(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/frontExhibitor/lintel/commitLintel',
    method: 'post',
    data: formData,
  });
}
